module.exports = __webpack_public_path__ + "assets/offie_9tipp_1920x1080.368e353b.pdf";